import axiosInstance from "./AxiosInstance";

class UsersService {
	constructor() {
		this.endpoint = "/api/users";
	}

	async getAll() {
		try {
			const response = await axiosInstance.get(this.endpoint);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}
	async getSearchAll(searchValue, searchType) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/search/${searchValue}/${searchType}`);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}

	async getByID(id) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/${id}`);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}

	async getDelimitations(id) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/${id}/delimitation`);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}

	async getOffices(id) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/${id}/offices`);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}

	async getGroups(id) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/${id}/groups`);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}

	async getGroupsAudit(id) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/${id}/groups-audit`);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}
	async getDelimitaionAudit(id) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/${id}/delimitation-audit`);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}
	async createDelimitation(data) {
		try {
			const response = await axiosInstance.post(`${this.endpoint}/delimitation`, data);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}

	async createOfficeUser(data) {
		try {
			const response = await axiosInstance.post(`${this.endpoint}/office/assign`, data);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}

	async createUserGroup(payload) {
		try {
			const response = await axiosInstance.post(`${this.endpoint}/createGroup`, payload);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}
	async deleteUserDelimitation(payload) {
		try {
			return (await axiosInstance.post(`${this.endpoint}/deactivate`, payload)).data;
		} catch (error) {
			console.error("Error deleting user delimitation:", error);
			throw error;
		}
	}

	async deactivateUserOfficer(payload) {
		try {
			return (await axiosInstance.post(`${this.endpoint}/office/deactivate`, payload)).data;
		} catch (error) {
			console.error("Error deactivating user office:", error);
			throw error;
		}
	}

	async deleteUserGoupDelimitation(payload) {
		try {
			return (await axiosInstance.post(`${this.endpoint}/deleteGroup`, payload)).data;
		} catch (error) {
			console.error("Error deleting user group delimitation:", error);
			throw error;
		}
	}

	async getUserAppointment(userId) {
		try {
			return (await axiosInstance.get(`${this.endpoint}/${userId}/appointment`)).data;
		} catch (error) {
			console.error("Error getting user appointment:", error);
			throw error;
		}
	}
}

const usersService = new UsersService();

export { usersService };
